import type { PublicApiKey } from '@/apilib';
import type { createPinModeApi } from './pinModeWrapper';

export const PinModeApiKey: PublicApiKey<typeof createPinModeApi> = {
  name: 'PinModeApi',
  public: true,
};
